import React, { useState } from 'react';
import { Moon, Sun, Sunrise } from 'lucide-react';

const ThemeToggle = ({ theme, onToggle, themeMode, onEnableAuto, onDisableAuto }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleClick = () => {
    if (themeMode === 'auto') {
      setShowMenu(true);
    } else {
      onToggle();
    }
  };

  const handleManualSelect = (selectedTheme) => {
    onDisableAuto();
    if (theme !== selectedTheme) {
      onToggle();
    }
    setShowMenu(false);
  };

  const handleAutoSelect = () => {
    onEnableAuto();
    setShowMenu(false);
  };

  return (
    <div className="relative">
      <button
        onClick={handleClick}
        onBlur={() => setTimeout(() => setShowMenu(false), 200)}
        className="p-2 rounded-lg bg-white/10 dark:bg-gray-800/50 hover:bg-white/20 dark:hover:bg-gray-700/50 transition-colors"
        aria-label={themeMode === 'auto' ? 'Theme options' : `Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        type="button"
      >
        {themeMode === 'auto' ? (
          <Sunrise className="w-5 h-5 text-orange-400" />
        ) : theme === 'dark' ? (
          <Sun className="w-5 h-5 text-yellow-400" />
        ) : (
          <Moon className="w-5 h-5 text-gray-700 dark:text-gray-300" />
        )}
      </button>

      {showMenu && (
        <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 py-2 z-50">
          <button
            onClick={() => handleManualSelect('light')}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2"
            type="button"
          >
            <Sun className="w-4 h-4" />
            Light Mode
          </button>
          <button
            onClick={() => handleManualSelect('dark')}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2"
            type="button"
          >
            <Moon className="w-4 h-4" />
            Dark Mode
          </button>
          <button
            onClick={handleAutoSelect}
            className="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2"
            type="button"
          >
            <Sunrise className="w-4 h-4" />
            Auto (Sunrise/Sunset)
          </button>
          {themeMode === 'auto' && (
            <div className="px-4 py-2 text-xs text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700 mt-2">
              Currently: {theme === 'dark' ? 'Dark' : 'Light'} mode
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;